import { ReactNode, useEffect } from 'react'
import { Backdrop, Stack, useTheme } from '@mui/material'
import { Typography } from 'ComponentLibrary/src/atoms/typography'
import { Button } from 'ComponentLibrary/src/atoms/Buttons/Button'
import { LottieWrapper } from 'ComponentLibrary/src/atoms/LottieWrapper'
import { LottieComponentProps } from 'lottie-react'

type SuccessBackdropProps = {
    open: boolean
    lottieAnimation: LottieComponentProps['animationData']
    successMsg: string
    nextIcon: ReactNode
    nextMsg: string
    nextAction: () => void
}
export const SuccessBackdrop = ({ open, lottieAnimation, successMsg, nextIcon, nextMsg, nextAction }: SuccessBackdropProps) => {
    const theme = useTheme()

    // Prevent scroll of document behind backdrop
    useEffect(() => {
        if (open) {
            document.body.style.overflow = 'hidden'
        } else {
            document.body.style.overflow = 'unset'
        }
        return () => {
            document.body.style.overflow = 'unset'
        }
    }, [open])

    return (
        <Backdrop open={open} sx={{ zIndex: 2, backdropFilter: 'blur(12px)', backgroundColor: 'initial' }}>
            <Stack direction="column" alignItems="center">
                <LottieWrapper style={{ width: 'min(70vw, 434px)', marginBottom: '-40px' }} animationData={lottieAnimation} />
                <Stack direction="column" gap={theme.spacing(8)} alignItems="center">
                    <Typography variant="headline1">{successMsg}</Typography>
                    <Button startIcon={nextIcon} label={nextMsg} onClick={nextAction} />
                </Stack>
            </Stack>
        </Backdrop>
    )
}
